"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEthereumAddressUserId = exports.isValidUserId = exports.toUserIdRaw = exports.toUserId = void 0;
const binaryUtils_1 = require("./binaryUtils");
const EthereumAddress_1 = require("./EthereumAddress");
const REGEX = /^0x[a-fA-F0-9]+$/;
const toUserId = (input) => {
    if (input instanceof Uint8Array) {
        return (0, binaryUtils_1.binaryToHex)(input, true);
    }
    else {
        if ((0, exports.isValidUserId)(input)) {
            return input.toLowerCase();
        }
        throw new Error(`not a valid UserID: "${input}"`);
    }
};
exports.toUserId = toUserId;
const toUserIdRaw = (userId) => {
    return (0, binaryUtils_1.hexToBinary)(userId);
};
exports.toUserIdRaw = toUserIdRaw;
const isValidUserId = (input) => {
    return REGEX.test(input);
};
exports.isValidUserId = isValidUserId;
const isEthereumAddressUserId = (userId) => {
    return userId.length === EthereumAddress_1.PREFIXED_STRING_LENGTH;
};
exports.isEthereumAddressUserId = isEthereumAddressUserId;
//# sourceMappingURL=UserID.js.map